export default {
  colors: {
    white: '#fff',
    black: '#000',
    gray: '#d0d0d0',
    gray_dark: '#4a4a4a',
    gray_light: '#e0e0e0',
    gray_light2: '#9b9b9b',
    red: '#db284e',
  },
  zIndex: {
    header: 999,
    imageEditor: 998,
    card: 997,
  },
}
